<template>
  <div class="mc-progress-bar-wrapper">
    <v-progress-linear
      :color=" context ? 'bg_secondary' : color" 
      :height="height"
      :rounded="rounded"
      :active="active"
      :indeterminate="indeterminate"
      v-bind="$attrs"  
      v-on="$listeners"
      :class="active ? 'mt-4 mb-2' : ''"
      background-opacity="0.5"
      >
      <template v-for="(_, slot) in $slots" v-slot:[slot]>
        <slot :name="slot"></slot>
      </template>
    </v-progress-linear>

    <div
      v-if=" active && (label || showProgress)"
    >
      <p 
        v-if="label"
      >
        {{ label ? label : '' }}
        {{ showProgress && inlineProgress ? progressLabel : '' }}
      </p>
      <p
        v-if="!inlineProgress && showProgress"
      >
        {{ progressLabel }}
      </p>
    </div>

    <div v-if="infoLabel || successLabel || warningLabel || errorLabel">
      <p
        v-if="errorLabel"
        class="status-msg error"
      >{{ errorLabel }}</p>
      <p
        v-if="warningLabel"
        class="status-msg warning"
      >{{ warningLabel }}</p>
      <p
        v-if="successLabel"
        class="status-msg success"
      >{{ successLabel }}</p>
      <p
        v-if="infoLabel"
        class="status-msg info"
      >{{ infoLabel }}</p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MCProgressBar',
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    height: {
      type: [Number, String],
      default: 6 
    },
    rounded : {
        type: Boolean,
        default: true,
    },
    active: {
        type: Boolean,
        default: true,
    },
    indeterminate: {
        type: Boolean,
        default: true,
    },
    context : {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    showProgress : {
      type: Boolean,
      default: false,
    },
    inlineProgress: {
      type: Boolean,
      default: true,
    },
    showPercentage : {
      type: Boolean,
      default: true,
    },
    successLabel: {
      type: String,
      default: "",
    },
    errorLabel: {
      type: String,
      default: "",
    },
    warningLabel: {
      type:String,
      default: ""
    },
    infoLabel : {
      type: String,
      default: '',
    },
  },

  computed: {
    progressLabel() {
      return `${Math.round(this.$attrs.value || 0)} ${this.showPercentage ? '%' : ''}`
    }
  }
}
</script>

<style scoped>
  .mc-progress-bar-wrapper
  {
    width: 100%;
    transition: all 1s ease-in-out;
  }
  .mc-progress-bar-wrapper p.status-msg
  {
    padding: 0.5rem;
    width: 100%;
    border-radius: 0.5rem;
    border-width: 2px;
    border-style: solid;
    color: var(--app-color-text-primary);

    &.error
    {
      border-color: var(--v-error-darken2) !important;
    }
    &.success
    {
      border-color: var(--v-success-darken3) !important;
    }
    &.warning
    {
      border-color: var(--v-warning-darken3) !important;
    }
    &.info
    {
      border-color: var(--v-info-darken3) !important;
      background-color: var(--v-info-lighten2) !important;
    }
  }
</style>